import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Loading from './Loading';
import './LandingPage.css';
import POTUS from '../assets/POTUS.mp4';
import maga from '../assets/maga.png';

function LandingPage() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleMagaClick = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate loading time
    setTimeout(() => {
      setIsLoading(false);
      navigate('/maga'); // Navigate after loading
    }, 3000); // 3 seconds loading time
  };

  return (
    <>
      {isLoading && <Loading />}
      <div className="landing-page">
        <div className="landing-content">
          <h1 className="landing-title">WELCOME TO THE OFFICE SER!</h1>
          <div className="video-container">
            <video 
              src={POTUS} 
              className="hero-video" 
              autoPlay 
              loop 
              muted 
              playsInline 
            />
          </div>
          <div className="button-container">
            <Link to="/maga" className="maga-link" onClick={handleMagaClick}>
              <img 
                src={maga} 
                alt="MAKE AMERICA GREAT AGAIN" 
                className="maga-image" 
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default LandingPage; 